export const CinemographHeroVideo = {
  ':type': 'mi-aem-luxury-spa/components/content/cinemograph-hero/v1/cinemograph-hero',
  assetProperties: {
    videoThumbnail: null,
    brightcoveVideoId: '6337495303112',
    altText: null,
    imagePath: null,
    videoAccountId: '6051814380001',
    videoPlatform: 'brightcove',
    assetType: 'cinemograph',
    playerId: 'default',
  },
  typeOfVideoControl: 'dark',
  applyScrim: true,
  overlapNavigation: true,
};

export const CinemographHeroVideoMobile = {
  ':type': 'mi-aem-luxury-spa/components/content/cinemograph-hero/v1/cinemograph-hero',
  assetProperties: {
    videoThumbnail: null,
    brightcoveMobileVideoId: '6337495303112',
    altText: null,
    imagePath: null,
    videoAccountId: '6051814380001',
    videoPlatform: 'brightcove',
    assetType: 'cinemograph',
    playerId: 'default',
  },
  typeOfVideoControl: 'dark',
  applyScrim: true,
  overlapNavigation: true,
};

export const CinemographHeroImage = {
  dynamicImage: {
    altText: 'testing pdt for update and efforts',
    assetPath: 'https://cache.marriott.com/is/image/marriotts7stage/rz-from-arrays-to-ngs-how-ch-44465',
    enableSmartCrop: true,
    dynamic: true,
    renditions: [
      {
        renditionPath:
          'https://cache.marriott.com/is/image/marriotts7stage/rz-from-arrays-to-ngs-how-ch-44465:Wide-Hor?wid=1440&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/rz-from-arrays-to-ngs-how-ch-44465:Wide-Hor?wid=2880&fit=constrain 2x',
        mediaValue: '1200px',
        width: 0,
        dynamic: true,
        smartCropType: null,
        damPath:
          '/content/dam/marriott-digital/rz/journey/en_us/photo/unlimited/assets/rz-from-arrays-to-ngs-how-ch-44465.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/is/image/marriotts7stage/rz-from-arrays-to-ngs-how-ch-44465:Wide-Hor?wid=960&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/rz-from-arrays-to-ngs-how-ch-44465:Wide-Hor?wid=1920&fit=constrain 2x',
        mediaValue: '992px',
        width: 0,
        dynamic: true,
        smartCropType: null,
        damPath:
          '/content/dam/marriott-digital/rz/journey/en_us/photo/unlimited/assets/rz-from-arrays-to-ngs-how-ch-44465.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/is/image/marriotts7stage/rz-from-arrays-to-ngs-how-ch-44465:Wide-Hor?wid=768&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/rz-from-arrays-to-ngs-how-ch-44465:Wide-Hor?wid=1536&fit=constrain 2x',
        mediaValue: '768px',
        width: 0,
        dynamic: true,
        smartCropType: null,
        damPath:
          '/content/dam/marriott-digital/rz/journey/en_us/photo/unlimited/assets/rz-from-arrays-to-ngs-how-ch-44465.jpg',
        mediaQuery: 'min-width',
        height: 0,
      },
      {
        renditionPath:
          'https://cache.marriott.com/is/image/marriotts7stage/rz-from-arrays-to-ngs-how-ch-44465:Wide-Hor?wid=364&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/rz-from-arrays-to-ngs-how-ch-44465:Wide-Hor?wid=728&fit=constrain 2x',
        mediaValue: '767px',
        width: 0,
        dynamic: true,
        smartCropType: null,
        damPath:
          '/content/dam/marriott-digital/rz/journey/en_us/photo/unlimited/assets/rz-from-arrays-to-ngs-how-ch-44465.jpg',
        mediaQuery: 'max-width',
        height: 0,
      },
    ],
    damPath:
      '/content/dam/marriott-digital/rz/journey/en_us/photo/unlimited/assets/rz-from-arrays-to-ngs-how-ch-44465.jpg',
  },
  ':type': 'mi-aem-luxury-spa/components/content/cinemograph-hero/v1/cinemograph-hero',
  assetProperties: {
    videoThumbnail: null,
    brightcoveVideoId: null,
    altText: 'testing pdt for update and efforts',
    imagePath:
      '/content/dam/marriott-digital/rz/journey/en_us/photo/unlimited/assets/rz-from-arrays-to-ngs-how-ch-44465.jpg',
    videoAccountId: null,
    videoPlatform: null,
    thumbnailAltText: null,
    assetType: 'image',
    playerId: null,
  },
  typeOfVideoControl: 'dark',
  applyScrim: true,
  overlapNavigation: true,
};

export const CinemographHeroProp = {
  ':type': [':type'],
  title: 'Cinemograph Hero',
};
